import Marionette from 'backbone.marionette';
import views from '../../views';
import { AdvertisingView } from '../../views';

export default class OnboardingController extends Marionette.Object {

	/**
	 * Method for /onboarding
	 */
	onboarding() {
		const
			rootView        = this.getOption('rootView'),
			onboardingView = new views.OnboardingView({
				game_title: 'Fantasy'
			});
		rootView.getRegion('main').show(onboardingView);
		const advertising = new AdvertisingView({
			ad_id: 'div-gpt-ad-1610421948488-0',
			ad_path:'game-selector',
			size: [[300, 250], [1,1]],
			pos: 2,
		});
		onboardingView.getRegion('advert').show(advertising);
	
	}
}